<template lang='pug'>
  v-app#app
    rc-error-handler
    rc-toolbar(v-if="initialized && $route.name !== 'no_permission'" ref="toolbar")
    v-content.white(v-if="loaded && initialized && destination.id && $route.name !== 'no_permission'" style="padding-top: 74px;")
      v-layout.justify-space-between.page-title.grey.lighten-3.pa-4(style="z-index: 8;")
        .headline.primary--text {{ title }}
        v-flex
          slot(name="appendTitle")
      v-container(fluid).px-0.pb-0.mx-0.mb-0.main-content
        transition(name="fade")
          router-view
    router-view(v-else-if="loaded && initialized && destination.id")
    .filler(v-else v-rc-loader="true")
</template>

<script>
import { mapState } from 'vuex';
import RcBreadcrumb from '@/components/RcBreadcrumb/RcBreadcrumb.vue';
import RcToolbar from './RcToolbar.vue';
import RcErrorHandler from '@/components/RcErrorHandler.vue';

export default {
  name: 'RcApp',
  computed: {
    ...mapState('app', ['initialized', 'destination']),
    title() {
      return this.$store.state.routes.breadcrumbs.filter(it => !!it.text).slice(-1).pop()?.text.toUpperCase();
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  created() {
    this.$store.dispatch('app/init').then(() => {
      Promise.all([
        this.$store.dispatch('countries/getCountries'),
        this.$store.dispatch('clients/getTypes'),
        this.$store.dispatch('clients/getTypeCategories'),
        this.$store.dispatch('clients/getSearchTypes'),
        this.$store.dispatch('contacts/getTypes'),
        this.$store.dispatch('contacts/getTypeCategories'),
        this.$store.dispatch('contacts/getSearchTypes'),
        this.$store.dispatch('customFields/getGroups'),
      ]).then(() => { this.loaded = true; });
    });
  },
  components: {
    RcToolbar,
    RcBreadcrumb,
    RcErrorHandler,
  },
};
</script>

<style lang="scss">
  #app {
    --primary: #015a94;
    --main-menu-height: 74px;
    --page-title-height: 80px;
    --main-navigation-height: calc(var(--main-menu-height) + var(--page-title-height));
    --detail-toolbar-height: 64px;
  }
</style>


<style lang="scss">
.v-menu__content {
  &::-webkit-scrollbar {
      -webkit-appearance: none;
  }

  &::-webkit-scrollbar:vertical {
      width: 11px;
  }

  &::-webkit-scrollbar:horizontal {
      height: 11px;
  }

  &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 2px solid white; /* should match background, can't be transparent */
      background-color: rgba(0, 0, 0, .5);
  }

  &::-webkit-scrollbar-track { 
      background-color: #fff; 
      border-radius: 8px; 
  } 
}

.v-pagination .v-pagination__item {
  font-size: 16px;
}

.p-relative {
  position: relative!important;
}

.page-title {
  position: fixed;
  width: 100vw;
  z-index: 2;
}
.main-content {
  padding-top: var(--page-title-height);
}
.hover-highlight:hover {
  background-color: #ececec;
}

.underline {
  text-decoration: underline;
}
.click {
  cursor: pointer;
}
.filler {
  height: calc(100vh - 74px);
}
.fill-height {
  height: 100%;
}

.fill-width {
  width: 100%;
}

.scroll-y-overflow {
  overflow-y: auto;
}

a {
  text-decoration: none;
}
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

@-moz-keyframes spin {
  from { -moz-transform: rotate(0deg); }
  to { -moz-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  from { -webkit-transform: rotate(0deg); }
  to { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
  from {transform:rotate(0deg);}
  to {transform:rotate(360deg);}
}
.load-wrapper.load-content.choice-load {
  .isPending:after {
    border-top: 6px solid var(--primary)!important;
  }
  .isPending.small:after {
    border-top: 3px solid var(--primary)!important;
  }
}
.load-wrapper.load-content {
  position: relative;
  > *:not(.isPending) {
    opacity: 0;
  }
  pointer-events: none;
  .isPending, {
    pointer-events: none;
  }
  .isPending > * {
    opacity: 0;
  }
  .isPending:after {
    content: '';
    position: absolute;
    top: var(--topOffset);
    left: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-animation-name: spin;
    -moz-animation-name: spin;
    animation-name: spin;
    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    -moz-animation-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    animation-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    z-index: 5;
  }
  .isPending.white:after {
    border-color: rgba(255, 255, 255, 0.2) !important;
    border-top-color: rgba(255, 255, 255, 0.4) !important;
  }
  .isPending:after {
    margin-top: -30px;
    margin-left: -30px;
    border: 6px solid rgba(0, 0, 0, 0.2);
    border-top: 6px solid var(--primary);
    width: 60px;
    height: 60px;
    -moz-box-shadow: 0 0 100px rgba(255, 255, 255, 0.12);
    box-shadow: 0 0 100px rgba(255, 255, 255, 0.12);
  }
  .isPending.small:after {
    margin-top: -15px;
    margin-left: -15px;
    border: 3px solid rgba(0, 0, 0, 0.2);
    border-top: 3px solid var(--primary);
    width: 30px;
    height: 30px;
  }
}
</style>
